// extracted by mini-css-extract-plugin
export default {"section":"CharactersList_section__ZGJOq","character-list":"CharactersList_character-list__mWSkD"};